import { Box, Button, Chip, InputAdornment, MenuItem, TextField } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SortRoundedIcon from "@mui/icons-material/SortRounded";

export default function AdminListToolbar({
    isAr,
    searchPlaceholder,
    search,
    onSearchChange,
    order,
    onOrderChange,
    orderOptions = [],
    totalLabel,
    totalCount = 0,
    onFilterClick,
    action = null,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
                mb: 2,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 1.5,
                    flex: 1,
                    minWidth: 0,
                }}
            >
                <Button
                    variant="outlined"
                    startIcon={<FilterAltOutlinedIcon />}
                    onClick={onFilterClick}
                    sx={{ minHeight: 40, whiteSpace: "nowrap" }}
                >
                    {isAr ? "تصفية" : "Filter"}
                </Button>

                <TextField
                    value={search}
                    onChange={(e) => onSearchChange?.(e.target.value)}
                    size="small"
                    placeholder={searchPlaceholder}
                    sx={{ minWidth: 240, flex: 1 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchOutlinedIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                />

                <TextField
                    select
                    size="small"
                    value={order}
                    onChange={(e) => onOrderChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SortRoundedIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                >
                    {orderOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 1,
                    justifyContent: "flex-end",
                }}
            >
                <Chip
                    label={`${totalLabel}: ${totalCount ?? 0}`}
                    color="primary"
                    variant="outlined"
                    sx={{ fontWeight: 700 }}
                />
                {action}
            </Box>
        </Box>
    );
}
